import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { FieldType } from 'store/fields/types';
import { OperationType } from 'store/operation/types';

import { OptimizePlansModal } from './OptimizePlansModal';

type OptimizePlansModalPropsType = {
  operation: OperationType;
  fields: FieldType[];
};

export const OptimizePlans = ({ operation, fields }: OptimizePlansModalPropsType) => {
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Button onClick={open} disabled={!operation.catalog_id}>
        {t('optimizePlans')}
      </Button>
      <OptimizePlansModal
        onClose={close}
        opened={opened}
        operationId={operation.id}
        fields={fields}
      />
    </>
  );
};
